import { Injectable } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

import { toastmessagesService } from "../../../core/services/messages/toastmessages.service";
@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private message: toastmessagesService,private translate: TranslateService,) { }

  makeFormData(objFormData) {
    let data = new FormData();
    for (var key in objFormData) {
     
      if( key === 'logo')
      {
        for(let i =0; i < objFormData[key].length; i++)
        {
          data.append(`images[${i}]`, objFormData[key][i], objFormData[key][i]['name']);
        }
      }
      else 
      {
        data.append(key, objFormData[key]);
      }
    }
   return data;
  }
  onlyDecimalNumberKey(event) {
    console.log(event.target.value.length);
    let input = event.currentTarget.value;
    console.log(event.keyCode)
    let charCode = (event.which) ? event.which : event.keyCode;
    console.log("dot char code", charCode);
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if ((input[0] == "0" || input[0] == undefined && charCode == 48)) {
      // event.target.value = 1;
      return false;
    }
    if (charCode == 46) {
      return false;
    }



    return true;
  }
  formatFileSize(bytes, decimalPoint) {
    if (bytes == 0) return '0 Bytes';
    let k = 1000,
      dm = decimalPoint || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
  appendData(key, value)
  {
    let data = new FormData();
    data.append(key, value);
    return data;
  }
  getTranslationResponse(status, label, text?) {
    if (status && label) {
      this.translate.get(label).subscribe((message) => {
        text = text ? text : ''
        console.log(text)
        this.sucesserrorMsg(status, `${message} ${text}`);
      })
    }

  }
  sucesserrorMsg(status, message)
  {
    this.message.messageHandler(status, message);
  }
}
